// extracted by mini-css-extract-plugin
export default {"switcher":"ResultSwitcher_switcher__NwgTB","btn":"ResultSwitcher_btn__BN1qn","btnActive":"ResultSwitcher_btnActive__R-y3X ResultSwitcher_btn__BN1qn"};